/* eslint-disable react/void-dom-elements-no-children */
import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';
// eslint-disable-next-line no-unused-vars
import { PedidoCabecalhoModel } from '../../../../../util/Models';

import { formatFloat } from '../../../../../util/functions';

/**
 * @typedef ItemsProps
 * @property {PedidoCabecalhoModel} pedido pedido
 * @property {function} setPedido Handle para alterar o pedido
 * @property {function} removeItem Handle para remover item
 * @property {function} editaItem Handle para alterar item
 * @property {function} handleFinalizar Handle para finalizar venda
 * @property {function} validaFinalizacaoPedido Handle para validar venda
 */

/**
 * @func ItemsPedido
 * @param {ItemsProps} props
 */
function ItemsPedido(props) {
  ItemsPedido.propTypes = {
    pedido: PropTypes.object,
  };

  const { pedido } = props;

  function renderItens() {
    return pedido.pedidoDetalhe.map(rowData => {
      const listaAdicionais = rowData.pedidoDetalhe;
      const respostasProd = [];
      const respostasObs = [];

      if (Array.isArray(rowData.perguntas)) {
        rowData.perguntas.forEach(p => {
          if (Array.isArray(p.respostas)) {
            p.respostas.forEach(r => {
              if (r.produto) {
                r.key = `${rowData.numeroItem}-${rowData.idProduto}-perg-${p.id}resp-${r.id}`;
                respostasProd.push(r);
              }
            });
          }
        });
      }

      if (Array.isArray(rowData.perguntas)) {
        rowData.perguntas.forEach(p => {
          if (Array.isArray(p.respostas)) {
            p.respostas.forEach(r => {
              if (r.observacao) {
                r.key = `${rowData.numeroItem}-${rowData.idProduto}-perg-${p.id}resp-${r.id}`;
                respostasObs.push(r);
              }
            });
          }
        });
      }

      const descricao = rowData.descricao.substring(0, 60);

      let qtdCasasDecimais = 0;

      if (rowData.quantidade === Math.round(rowData.quantidade)) {
        qtdCasasDecimais = 0;
      } else {
        qtdCasasDecimais = 3;
      }

      return (
        <div className="card-item" key={rowData.numeroItem}>
          <div className="div-descricao-valor">
            <div>
              <span className="quantidade">
                {formatFloat(rowData.quantidade, qtdCasasDecimais)}x{' '}
              </span>
              <span className="descricao">{descricao}</span>
            </div>
            <span className="valor-subtotal">R${formatFloat(rowData.valorTotal, 2)}</span>
          </div>

          <div className="div-observacao-imagem">
            <div style={{ flex: 1 }}>
              {listaAdicionais
                ? listaAdicionais.map(a => {
                    return (
                      <div
                        key={`add-${rowData.numeroItem}-${a.idProduto}`}
                        style={{ marginLeft: 10 }}
                      >{`+${a.quantidade}${a.unidade} x ${a.descricao}`}</div>
                    );
                  })
                : null}

              {respostasProd
                ? respostasProd.map(r => {
                    let quantidadeDescricao = '';
                    if (r.produto) {
                      quantidadeDescricao = `+${r.quantidadeResposta}${r.produto.produtoUnidade.sigla} x ${r.produto.descricao}`;
                    } else {
                      quantidadeDescricao = `*${r.observacao?.descricao}`;
                    }

                    return (
                      <div key={`${r.key}`} style={{ marginLeft: 10 }}>
                        {quantidadeDescricao}
                      </div>
                    );
                  })
                : null}

              {rowData.pedidoDetalheObs.map(o => {
                return (
                  <div
                    key={`obs-${rowData.numeroItem}-${o.idObservacaoProduto}`}
                    style={{ marginLeft: 10 }}
                  >{`*${o.descricaoObservacaoProduto}`}</div>
                );
              })}

              {respostasObs
                ? respostasObs.map(r => {
                    let quantidadeDescricao = '';
                    if (r.produto) {
                      quantidadeDescricao = `+${r.quantidadeResposta}${r.produto.produtoUnidade.sigla} x ${r.produto.descricao}`;
                    } else {
                      quantidadeDescricao = `*${r.observacao.descricao}`;
                    }

                    return (
                      <div key={`${r.key}`} style={{ marginLeft: 10 }}>
                        {quantidadeDescricao}
                      </div>
                    );
                  })
                : null}

              {rowData.observacao ? (
                <div style={{ marginLeft: 10 }}>{`*${rowData.observacao}`}</div>
              ) : null}
            </div>
            <div>
              {rowData.urlImagem ? (
                <img
                  className="image-item"
                  src={rowData.urlImagem}
                  onError={event => {
                    event.target.style = 'display: none';
                  }}
                  alt="produto"
                />
              ) : null}
            </div>
          </div>
        </div>
      );
    });
  }

  return <Container>{renderItens()}</Container>;
}

export default ItemsPedido;
